import { useEffect, useState } from 'react';

function readZoom(map) {
  const zoom = map?.getZoom?.();
  return typeof zoom === 'number' ? zoom : 0;
}

export function useMapZoom(map) {
  const [zoom, setZoom] = useState(() => readZoom(map));

  useEffect(() => {
    if (!map) {
      queueMicrotask(() => setZoom(0));
      return undefined;
    }

    const syncZoom = () => setZoom(readZoom(map));

    queueMicrotask(syncZoom);
    const listener = map.addListener('zoom_changed', syncZoom);

    return () => {
      listener.remove();
    };
  }, [map]);

  return zoom;
}
